import { toast } from "react-toastify";
import api from "../../../api";

/**
 * Tutor access states for past papers / mock exams, as returned by the API (access_status and,
 * for a chosen group, group_status). `viewable` is only a filter value.
 */
export const ACCESS_META = {
  assigned: { label: "Assigned", color: "#0369a1", bg: "#e0f2fe", hint: "Admin already gave this to your students" },
  approved: { label: "Approved", color: "#15803d", bg: "#dcfce7", hint: "Admin approved your request" },
  pending: { label: "Pending", color: "#b45309", bg: "#fef3c7", hint: "Waiting for admin review" },
  rejected: { label: "Rejected", color: "#b91c1c", bg: "#fee2e2", hint: "The admin rejected this request" },
  not_requested: { label: "No access", color: "#4b5563", bg: "#f3f4f6", hint: "Request access to open it" },
};

export const ACCESS_FILTERS = [
  { value: "", label: "All" },
  { value: "viewable", label: "Can view" },
  { value: "assigned", label: "Assigned" },
  { value: "pending", label: "Pending" },
  { value: "not_requested", label: "Not requested" },
  { value: "rejected", label: "Rejected" },
];

export const accessOf = (paper) => paper?.access_status || "not_requested";

export const canView = (paper) => ["assigned", "approved"].includes(accessOf(paper));

export const isRequestable = (paper) => ["not_requested", "rejected"].includes(accessOf(paper));

/** Open the paper PDF in a new tab. A blob responseType turns JSON error bodies into a Blob too. */
export async function openPaperPdf(url) {
  const readMessage = async (blob, fallback) => {
    try {
      const parsed = JSON.parse(await blob.text());
      return parsed?.message || fallback;
    } catch (_) {
      return fallback;
    }
  };

  try {
    const response = await api.get(url, { responseType: "blob" });
    const contentType = (response.headers?.["content-type"] || "").toLowerCase();

    if (!contentType.includes("application/pdf")) {
      toast.info(await readMessage(response.data, "No PDF is available for this paper yet."));
      return;
    }

    const objectUrl = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
    window.open(objectUrl, "_blank", "noopener,noreferrer");
    setTimeout(() => window.URL.revokeObjectURL(objectUrl), 60000);
  } catch (error) {
    const data = error?.response?.data;
    toast.error(data instanceof Blob ? await readMessage(data, "Failed to open paper PDF.") : "Failed to open paper PDF.");
  }
}
